const profileDE = {
    "edit": {
        "title": "Bearbeiten Sie Ihr Profil",
        "form": {
            "label": {
                "profileImage": "Profilbild",
                "streetAndNumber": "Meine Straße und Hausnummer",
                "postalCode": "Postleitzahl",
                "city": "Stadt",
                "country": "Land",
                "vatNumber": "Umsatzsteuer-Identifikationsnummer",
                "nationalTaxNumber": "Nationale Steuernummer",
                "businessRegistrationNumber": "Handelsregisternummer",
                "vatStatus": "Umsatzsteuerstatus",
                "businessType": "Geschäftsart",
                "vatExemptDocument": "Umsatzsteuerbefreiungsdokument",
                "businessCertificate": "Gewerbeschein",
                "preferredPaymentMethod": "Bevorzugte Zahlungsmethode",
                "paypalEmail": "Paypal-E-Mail",
                "accountHolderName": "Kontoinhaber Name",
                "bankName": "Bankname",
                "bankAddress": "Bankadresse",
                "iban": "IBAN"
            },
            "option": {
                "preferedMethod": {
                    "paypal": "Paypal",
                    "bankAccount": "Bankkonto"
                }
            },
            "help_text": {
                "profileImage": "Laden Sie JPG-Formate hoch, Auflösung nur 300x300 px, max. Größe 300 KB.",
                "iban": "Denken Sie an das Ländervorzeichen, z.B. DE, FR, ES"
            },
            "button": {
                "submit": "Einreichen"
            }
        },
        "message": {
            "success": "Ihr Profil wurde aktualisiert!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        },
        "modal": {
            "header": "Sind Sie sicher, dass Sie Ihr Profil ändern möchten?",
            "body": "Hiermit garantieren Sie, dass alle angegebenen Daten wahrheitsgemäß sind. Sie sind allein und rechtlich verantwortlich für die angegebenen Daten und deren Wahrheitsgehalt.",
            "button": {
                "cancel": "Abbrechen",
                "confirm": "Bestätigen"
            }
        }
    },
    "set_new_password": {
        "title": "Neues Passwort festlegen",
        "form": {
            "label": {
                "currentPassword": "Aktuelles Passwort",
                "newPassword": "Neues Passwort",
                "repeatNewPassword": "Neues Passwort wiederholen"
            },
            "button": {
                "submit": "Einreichen"
            },
            "validation": {
                "oldPasswordRequired": "Ihr altes Passwort ist erforderlich",
                "newPasswordMin": "Ihr Passwort sollte mindestens 10 Zeichen lang sein",
                "newPasswordRequired": "Neues Passwort ist erforderlich",
                "passwordsMustMatch": "Neues Passwort muss übereinstimmen"
            }
        },
        "message": {
            "success": "Ihr Passwort wurde geändert!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        },
        "modal": {
            "header": "Sind Sie sicher, dass Sie Ihr Passwort ändern möchten?",
            "body": "Bitte bestätigen"
        }
    },
    "panel": {
        "label": {
            "emailAddress": "E-Mail-Adresse",
            "paypalEmailAddress": "Paypal-E-Mail-Adresse",
            "phone": "Telefon",
            "streetAndHouseNumber": "Straße und Hausnummer",
            "postalCode": "Postleitzahl",
            "city": "Stadt",
            "country": "Land",
            "paymentMethod": "Zahlungsmethode",
            "accountNumberHolder": "Kontoinhaber",
            "bankName": "Bankname",
            "iban": "IBAN",
            "bic": "BIC",
            "bankAddress": "Bankadresse",
            "paypal": "Paypal",
            "bankAccount": "Bankkonto"
        }
    },
    "payment_method": {
        "title": "Zahlungsmethode",
        "label": {
            "card_number": "Kartennummer",
            "card_expiry": "Ablaufdatum",
            "default_method": "Standard",
            "manage_method": "Verwalten",
            "add_method": "Hinzufügen"
        }
    },
    "withholding_tax": {
        "title": "Quellensteuer",
        "form": {
            "label": {
                "taxPercentage": "Steuersatz",
                "whtStatus": "WHT-Status",
                "whtLicense": "WHT-Lizenz"
            },
            "help_text": {
                "uploadDocument": "Bitte laden Sie Ihr Quellensteuerdokument hoch."
            },
            "button": {
                "submit": "Einreichen",
                "removeFile": "Entfernen?"
            },
            "message": {
                "whtStatusText": "Gemäß Artikel 31 des kroatischen Körperschaftsteuergesetzes wird eine Quellensteuer von 15-25% auf Nichtansässige erhoben. Wenn Sie jedoch in einem Land wohnen, das ein Abkommen zur Vermeidung der Doppelbesteuerung mit Kroatien hat, können Sie sich für einen reduzierten Steuersatz qualifizieren. Sie können überprüfen, ob Ihr Land auf <1><strong>diesem Link</strong></1> aufgeführt ist.",
                "whtApplyRateText": "Um den reduzierten Satz zu beantragen, klicken Sie bitte auf <1><strong>dieses Dokument</strong></1>. Laden Sie das Formular herunter, füllen Sie es aus und reichen Sie es ein, um von dem im Abkommen festgelegten Satz zu profitieren, wenn Sie berechtigt sind."
            }
        },
        "message": {
            "success": "WHT-Lizenz erfolgreich eingereicht. Sie wird von unserem Team bearbeitet.",
            "error": "Beim Aktualisieren ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
        }
    }
};

export default profileDE;